export default {
  title: 'Speichere Kontakt- und Zahlungsdaten',
  form: {
    remember_me: {
      label: 'Erstelle ein Konto für schnellere Bestellungen in Zukunft.',
    },
  },
};
